import { ActionType } from '../infrastructure/actionTypes';

export default (showModal: boolean = false, action: any) => {
  switch (action.type) {
    case ActionType.CREATE_ORDER_DONE:
    {
        showModal = true;
        break;
    }
    case ActionType.CREATE_ORDER_DISMISSED:
    {
        showModal = false;
        break;
    }
  }
  return showModal;
};



// WEBPACK FOOTER //
// ./src/reducers/orderCreated.ts